
























































































































import Vue from 'vue';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import Component from 'vue-class-component';
import download from 'downloadjs';

// @ts-ignore
import APIService from '@/services/api';
import {IInterface, ITag} from '../shared/services/models/Interface';
import {ISetting} from '../shared/services/models/Setting';
import {IStatus} from '../shared/services/models/Status';
import {ILicences} from '../shared/services/models/Licences';
import {IStatisticsSummary} from '../shared/services/models/StatisticsSummaries';
import {IRecording} from '../shared/services/models/Recording';
import {ICinegyRouteSource} from '../shared/services/models/CinegyRouteSource';

import { Watch } from 'vue-property-decorator';
import { IServer } from '../shared/services/models/Server';

interface InterfaceValues {
    inputBw: number;
    inputCount: number;
    outputBw: number;
    outputCount: number;
}

// The @Component decorator indicates the class is a Vue component
@Component({
    components: {
        // @ts-ignore
        InterfaceComponent : require('@/shared/components/Interface').default,
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['serverStatus', 'interfaces', 'statuses', 'updating', 'licences', 'statisticsSummary', 'tags', 'cinegyRouteDestinations', 'capturePath', 'recordings', 'settings', 'cinegyRouteSources']),
    },
    methods: {
        ...mapMutations([]),
        ...mapActions(['updateInterfaces', 'startInterface', 'stopInterface', 'forceStopInterface', 'restartInterface', 'saveInterface', 'updateStatus', 'updateLicences', 'updateRecordings', 'updateAllowBlockLists', 'updateStatisticsSummary', 'updateTags']),
    },
})
// @ts-ignore
export default class InterfacesComponent extends Vue {
    private interfaces!: IInterface[];
    private statuses!: IStatus[];
    private updating!: boolean;
    private licences!: ILicences;
    private statisticsSummary!: IStatisticsSummary;
    private tags!: ITag[];
    private cinegyRouteDestinations!: string[];
    private cinegyRouteSources!: ICinegyRouteSource[];
    private capturePath!: string;
    private recordings!: IRecording[];
    private settings!: ISetting[];
    private serverStatus!: IServer;


    private lastTimestamp: string|null = '';
    private updateHandle: number = 0;
    private statisticsSummaryUpdateHanbdle: number = 0;
    private updateAllowBlockListsHandle: number = 0;
    private updateRecordingsHandle: number = 0;
    private shiftDown: boolean = false;
    private tagFilter: string | undefined = 'all';
    private interfaceValues: { [key: string]: InterfaceValues } = {};
    private showProgress: boolean = true;
    private MultipleTitle: string = 'Restart progress';
    private progressValue: number = 0;
    private progressMax: number = 100;
    private progressName: string = '';

    private StickyBarKey: string = 'ui.titlebar.sticky';
    private RequireSLAModeKey: string = 'interface.require_sla_mode';

    private uploadFile: any = null;
    private uploadFileInterface: string | undefined = undefined;

    private TagFilters: any[] = [];

    @Watch('tagFilter')
    private tagFilterChange(newValue: string) {
        localStorage.setItem('tag-filter-value', newValue);
    }

    @Watch('tags')
    private tagChange(newValue: string) {
        this.TagFilters = this.tagFilters;
    }

    private get Interfaces(): IInterface[] {
        if (this.interfaces && Array.isArray(this.interfaces)) {
            try {
                return this.interfaces;
            } catch (E) {
                window.console.log('error', E);
            }
        }

        return [];
    }

    private get IsFilterIsTag(): boolean {
        if (!this.tagFilter || this.tagFilter === 'all' || this.tagFilter.indexOf('filter:') !== -1) {
            return false;
        }

        return true;
    }

    private get Tags(): ITag[] {
        if (this.tags) {
            return this.tags;
        }

        return [];
    }

    private get RequiteSLAMode(): boolean {
        const s = this.Settings;

        if (s.hasOwnProperty(this.RequireSLAModeKey)) {
            try {
                return s[this.RequireSLAModeKey].toLowerCase() === 'true';
            } catch (E) { /* nothing to do */}
        }

        return false;
    }

    private get tagFilters(): any[] {
        const ret: any[] = [];

        ret.push({ value: 'all', text: 'All'});
        ret.push({
            label: 'Filters',
            options: [
                { value: 'filter:active', text: 'Active' },
                { value: 'filter:idle', text: 'Idle' },
               /* { value: 'filter:configured', text: 'Configured' },
                { value: 'filter:free', text: 'Free' }, */
            ],
        });
        const ltags = {
            label: 'Tags',
            options: [] as any[],
        };

        this.tags.forEach((t) => {
            const value: string = t.id;
            const text: string = t.name;
            ltags.options.push(
                {
                    value,
                    text,
                });
        });

        ret.push(ltags);

        return ret;
    }

    private get InputCountSummary(): number {
        let ret: number = 0;
        const u: boolean = this.updating;

        Object.keys(this.interfaceValues).forEach((is) => {
            ret += this.interfaceValues[is].inputCount;
        });

        return ret;
    }

    private get OutputCountSummary(): number {
        let ret: number = 0;
        const u: boolean = this.updating;

        Object.keys(this.interfaceValues).forEach((is) => {
            ret += this.interfaceValues[is].outputCount;
        });

        return ret;
    }

    private get InputBandwidthSummary(): string {
        let ret: number = 0;
        const u: boolean = this.updating;

        Object.keys(this.interfaceValues).forEach((is) => {
            ret += this.interfaceValues[is].inputBw;
        });

        return ret.toFixed(2);
    }

    private get OutputBandwidthSummary(): string {
        let ret: number = 0;
        const u: boolean = this.updating;

        Object.keys(this.interfaceValues).forEach((is) => {
            ret += this.interfaceValues[is].outputBw;
        });

        return ret.toFixed(2);
    }

    private get NetworkDevices(): { [key: string]: string } {
        if (this.serverStatus) {
            return this.serverStatus.address;
        }

        return {};
    }

    private changeInterfaceValue(interfaceId: string, key: string, value: number) {
        if (!(interfaceId in this.interfaceValues)) {
            this.interfaceValues[interfaceId] = {
                inputBw: 0,
                outputBw: 0,
                inputCount: 0,
                outputCount: 0,
            };
        }
        Vue.set(this.interfaceValues[interfaceId], key, value);
    }

    private downloadConfig(interfaceId: string, inter: IInterface) {
        const interStr: string = JSON.stringify(inter);
        const interObj: IInterface = JSON.parse(interStr);
        // @ts-ignore
        interObj.live = undefined;
        // should get config from DB, but for now we'll do it this way
        download(JSON.stringify(interObj, null, 4), `${inter.nr}-${inter.id}`, 'text/json' );
    }
    private uploadConfig(interfaceId: string, inter: IInterface) {
        // should post the config to the DB but for now we'll do it this way
        this.uploadFileInterface = interfaceId;
        // @ts-ignore
        this.$bvModal.show('uploadConfig');
    }

    private getInterfaceName(id: string): string {
        for (const i of this.interfaces) {
            if (i.id === id) {
                return i.name;
            }
        }

        return 'Not found';
    }
    private getInterface(id: string): IInterface | null {
        for (const i of this.interfaces) {
            if (i.id === id) {
                return i;
            }
        }

        return null;
    }

    private updateAndSaveInterface(id: string, inter: IInterface): string {
        for (const [ii, i] of this.interfaces.entries()) {
            if (i.id === id) {
                Vue.set(this.interfaces[ii], 'output', inter.output);
                Vue.set(this.interfaces[ii], 'input', inter.input);
                Vue.set(this.interfaces[ii], 'sla_mode', inter.sla_mode);
                Vue.set(this.interfaces[ii], 'tags', inter.tags);
                Vue.set(this.interfaces[ii], 'auto_start', inter.auto_start);
                Vue.set(this.interfaces[ii], 'name', inter.name);
                Vue.set(this.interfaces[ii], 'allow_block_list_id', inter.allow_block_list_id);
                Vue.set(this.interfaces[ii], 'packet_bunching', inter.packet_bunching);

                i.sla_mode = inter.sla_mode;
                i.tags = inter.tags;
                i.auto_start = inter.auto_start;
                i.name = inter.name;
                i.allow_block_list_id = inter.allow_block_list_id;
                i.packet_bunching = inter.packet_bunching;
                // @ts-ignore
                this.Save(this.interfaces[ii]);

            }
        }

        return 'Not found';
    }

    private processUploadedConfig() {
        const reader = new FileReader();

        reader.onload = (e) => {
            if (e && e.target && typeof e.target.result === 'string') {
                const inter: IInterface = JSON.parse(e.target.result);

                // @ts-ignore
                this.$bvModal.msgBoxConfirm(`Overwrite configuration of interface ${this.getInterfaceName(this.uploadFileInterface)}`, {
                    title: 'Upload configuration',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(async (value) => {
                    if (value && this.uploadFileInterface) {
                        this.updateAndSaveInterface(this.uploadFileInterface, inter);
                    }
                });
            }
        };

        reader.readAsText(this.uploadFile);
    }

    private get Settings(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        if (this.settings && Array.isArray(this.settings)) {
            this.settings.forEach((s) => {
                ret[s.key] = s.value;
            });
        }

        return ret;
    }

    private get StickyBar(): boolean {
        const s = this.Settings;

        if (s.hasOwnProperty(this.StickyBarKey)) {
            return s[this.StickyBarKey] === 'true';
        }

        return false;
    }

    private isInterfaceVisible(inter: IInterface) {
        if (!this.tagFilter || this.tagFilter === 'all') {
            return true;
        }

        if (this.tagFilter.indexOf('filter:') !== -1) {
            switch (this.tagFilter.toLowerCase()) {
                case 'filter:active': return inter.live && inter.live.state === 1;
                case 'filter:idle': return (inter.live && inter.live.state === 0) || inter.live === undefined;
                case 'filter:configured': return (Array.isArray(inter.input) && inter.input.length !== 0 || ( Array.isArray(inter.output) && inter.output.length > 0) || !Array.isArray(inter.output) && inter.output.multi || !Array.isArray(inter.input) && inter.input.multi);
                case 'filter:free': return (Array.isArray(inter.input) && inter.input.length === 0 && ( Array.isArray(inter.output) && inter.output.length === 0));
            }
        } else {
            if (inter && inter.tags && inter.tags.length > 0) {
                // tslint:disable-next-line
                for (let i: number = 0; i < inter.tags.length; i++) {
                    const tag: ITag = inter.tags[i];

                    if (tag.id === this.tagFilter) {
                        return true;
                    }
                }
            }
        }

        return false;
    }
   /* private updateStatus(): void{}
    private updateInterfaces(): void{}*/
    /*private updateStatus(): void {
        let timestamp: string = '';

        this.interfaces.forEach((i) => {
            if (i.state === 1 && i.lastTimestamp) {
                if (timestamp !== '' && new Date(i.lastTimestamp) < new Date(timestamp)) {
                    timestamp = i.lastTimestamp;
                } else if (timestamp === '') {
                    timestamp = i.lastTimestamp;
                }
            }
        });
        const now: number = (new Date()).getTime();
        const timestampTime = (new Date(timestamp + 'Z')).getTime();

        if ((now - timestampTime) / 1000 > 120) {
            timestamp = new Date(Date.now() - 120000).toUTCString();
        }

        APIService.GetStatus(timestamp).then((data: IStatus[]) => {
            data.sort((l: IStatus, r: IStatus): number => {
                if (l && r) {
                    if (new Date(l.timestamp) > new Date(r.timestamp)) {
                        return 1;
                    }
                } else if (new Date(r.timestamp) > new Date(l.timestamp)) {
                    return -1;
                }

                return 0;
            }).forEach((status: IStatus) => {
                this.interfaces.forEach((i) => {
                    if (i.id === status.id) {
                        if (!i.live) {
                            i.live = {
                                id: status.id,
                                nr: i.nr,
                                name: status.name,
                                type: status.type,
                                state: status.state,
                                auto_start: status.auto_start,
                                input: status.input,
                                output: status.output,
                                statistics: [],
                            };
                        }

                        if ((i.lastTimestamp && new Date(status.timestamp) > new Date(i.lastTimestamp))) {
                            i.live.statistics.push(status);
                        } else if (i.lastTimestamp === undefined && status !== undefined && status !== null && status.timestamp !== undefined && status.timestamp !== null) {
                            i.live.statistics.push(status);
                        }

                        while (i.live.statistics.length > (150)) { // 1s between each point and 2.5 min of data
                            i.live.statistics.shift();
                        }

                        i.state = status.state;
                        if (status.timestamp) {
                            this.lastTimestamp = status.timestamp;
                            i.lastTimestamp = status.timestamp;
                        }
                    }
                });
            });
            this.statuses = data;
        }).catch((err: any) => {
            // tslint:disable-next-line:no-console
            console.log('Error getting statistics', err);
        });
    }*/
    private startAllInterfacesVisible(): void {
        let iNames: string = '';
        this.interfaces.forEach((i) => {
            if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                if (iNames.length > 0) {
                    iNames += ', ';
                }
                iNames += i.name;
            }
        });
        // @ts-ignore
        this.$bvModal.msgBoxConfirm(`Start ${iNames}`, {
            title: 'Start all visible Interfaces',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then(async (value) => {
            if (value) {
                this.progressName = '';
                // @ts-ignore
                this.$bvModal.show('modalMultipleCommands');
                let count: number = 0;
                this.interfaces.forEach((i) => {
                    if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                       count++;
                    }
                });
                this.MultipleTitle = 'Start Interfaces';
                this.progressMax = count;
                this.progressValue = 0;
                /*this.interfaces.forEach(async (i) =>  {
                    if (this.isInterfaceVisible(i)) {
                        await this.Start(i);
                        this.progressValue++;
                    }
                });*/
                for (const i of this.interfaces) {
                    if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                        this.progressName = i.name;
                        await this.Start(i);
                        await this.waitForStateOrTime(i.id, 1, 500);
                        this.progressValue++;
                    }
                }
                setTimeout(() => {
                    // @ts-ignore
                    this.$bvModal.hide('modalMultipleCommands');
                }, 200);
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private stopAllInterfacesVisible(): void {
        let iNames: string = '';
        this.interfaces.forEach((i) => {
            if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                if (iNames.length > 0) {
                    iNames += ', ';
                }
                iNames += i.name;
            }
        });
        // @ts-ignore
        this.$bvModal.msgBoxConfirm(`Stop ${iNames}`, {
            title: 'Stop all visible Interfaces',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then(async (value) => {
            if (value) {
                this.progressName = '';
                // @ts-ignore
                this.$bvModal.show('modalMultipleCommands');
                let count: number = 0;
                this.interfaces.forEach((i) => {
                    if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                       count++;
                    }
                });
                this.MultipleTitle = 'Stop Interfaces';
                this.progressMax = count;
                this.progressValue = 0;
                /*this.interfaces.forEach(async (i) => {
                    if (this.isInterfaceVisible(i)) {
                        await this.Stop(i);
                        this.progressValue++;
                    }
                });*/
                for (const i of this.interfaces) {
                    if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                        this.progressName = i.name;
                        await this.Stop(i);
                        await this.waitForStateOrTime(i.id, 0, 500);
                        this.progressValue++;
                    }
                }
                setTimeout(() => {
                    // @ts-ignore
                    this.$bvModal.hide('modalMultipleCommands');
                }, 200);
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private restartAllInterfacesVisible(): void {
        let iNames: string = '';
        this.interfaces.forEach((i) => {
            if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                if (iNames.length > 0) {
                    iNames += ', ';
                }
                iNames += i.name;
            }
        });
        // @ts-ignore
        this.$bvModal.msgBoxConfirm(`Restart ${iNames}`, {
            title: 'Restart all visible Interfaces',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then(async (value) => {
            if (value) {
                this.progressName = '';
                // @ts-ignore
                this.$bvModal.show('modalMultipleCommands');
                let count: number = 0;
                this.interfaces.forEach((i) => {
                    if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                       count++;
                    }
                });
                this.MultipleTitle = 'Restart Interfaces';
                this.progressMax = count;
                this.progressValue = 0;
                /*this.interfaces.forEach(async (i) => {
                    if (this.isInterfaceVisible(i)) {
                        console.log('Waiting for RestartInterface, restartAllInterfacesVisible');
                        await this.Restart(i);
                        this.progressValue++;
                        console.log('done Waiting for RestartInterface, restartAllInterfacesVisible');

                    }
                });*/
                for (const i of this.interfaces) {
                    if (this.isInterfaceVisible(i) && (!this.RequiteSLAMode || (this.RequiteSLAMode && i.sla_mode !== ''))) {
                        this.progressName = i.name;
                        await this.Restart(i);
                        await this.waitForStateOrTime(i.id, 2, 200);

                        this.progressValue++;
                    }
                }
                setTimeout(() => {
                    // @ts-ignore
                    this.$bvModal.hide('modalMultipleCommands');
                }, 200);
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private async sleep(ms: number): Promise<void>  { // does this work?
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }

    private async waitForStateOrTime(id: string, state: number, ms: number) {
        let loops = 0;
        while (loops <= (ms / 10)) {
            const i = this.getInterface(id);
            if (i !== null && i.state === state) {
                break;
            }
            await this.sleep(10);
            loops++;
        }
    }

    private async Start(i: IInterface) {
        const id: string = i.id;
        const nr: number = i.nr;
        // @ts-ignore
        await this.startInterface({id, nr});
    }

    private async Stop(i: IInterface) {
        const id: string = i.id;
        const nr: number = i.nr;
        // @ts-ignore
        await this.stopInterface({id, nr});
    }

    private ForceStop(i: IInterface) {
        const id: string = i.id;
        const nr: number = i.nr;
        // @ts-ignore
        this.forceStopInterface({id, nr});
    }

    private async Restart(i: IInterface) {
        const id: string = i.id;
        const nr: number = i.nr;

        // @ts-ignore
        await this.restartInterface({id, nr});
    }

    private Save(i: IInterface) {
        // @ts-ignore
        this.saveInterface(i);
    }

    private get StatisticsSummary(): { [key: string]: IStatisticsSummary } {
        const ret: { [key: string]: IStatisticsSummary } = {};

        if (this.statisticsSummary && Array.isArray(this.statisticsSummary.long_interval) && Array.isArray(this.statisticsSummary.short_interval)) {

            this.statisticsSummary.long_interval.forEach((s) => {
                if (!ret.hasOwnProperty(s.interface_id)) {
                    ret[s.interface_id] = {
                        long_interval: [],
                        short_interval: [],
                    };
                }
                ret[s.interface_id].long_interval.push(s);
            });

            this.statisticsSummary.short_interval.forEach((s) => {
                if (!ret.hasOwnProperty(s.interface_id)) {
                    ret[s.interface_id] = {
                        long_interval: [],
                        short_interval: [],
                    };
                }
                ret[s.interface_id].short_interval.push(s);
            });

        }

        return ret;
    }

    private mounted() {
        /*APIService.GetInterfaces().then((data) => {
            // @ts-ignore
            this.interfaces = data;
        }).catch((err: any) => {
            // tslint:disable-next-line:no-console
            console.log('Error gettings interfaces', err);
        });*/
        const tagfilter = localStorage.getItem('tag-filter-value');
        if (tagfilter) {
            this.tagFilter = tagfilter;
        }
        // @ts-ignore
        this.updateTags();
        // @ts-ignore
        this.updateLicences();
        // @ts-ignore
        this.updateInterfaces();
        // @ts-ignore
        this.updateHandle = setInterval(() => {
            if (!this.updating) {
                // @ts-ignore
                this.updateStatus();
            }
        }, 1500);

        // @ts-ignore
        this.updateAllowBlockLists();
        // @ts-ignore
        this.updateAllowBlockListsHandle = setInterval(() => {
            // @ts-ignore
            this.updateAllowBlockLists();
        }, 60000);

        // @ts-ignore
        this.updateRecordings();
        // @ts-ignore
        this.updateRecordingsHandle = setInterval(() => {
            // @ts-ignore
            this.updateRecordings();
        }, 45000);

        // @ts-ignore
        this.updateStatisticsSummary();
        // @ts-ignore
        this.statisticsSummaryUpdateHanbdle = setInterval(() => {
            // @ts-ignore
            this.updateStatisticsSummary();
        }, 20000);

        window.addEventListener('keyup', (e: KeyboardEvent) => {
            this.shiftDown = e.shiftKey;
        });
        window.addEventListener('keydown', (e: KeyboardEvent) => {
            this.shiftDown = e.shiftKey;
        });
    }

    private destroyed() {
        clearInterval(this.updateHandle);
        clearInterval(this.updateAllowBlockListsHandle);
        clearInterval(this.updateRecordingsHandle);
        clearInterval(this.statisticsSummaryUpdateHanbdle);
    }
}
